import { FC, HTMLAttributes } from 'react'

import { twMerge } from '~/lib/utils'

type SubSectionHeadingProps = HTMLAttributes<HTMLHeadingElement>

export const SubSectionHeading: FC<SubSectionHeadingProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <h3
      className={twMerge('text-lg font-bold leading-[140%]', className)}
      {...props}
    >
      {children}
    </h3>
  )
}
